import { j as w } from "./jsx-runtime.DGlMoOmv.js";
import { c as s } from "./index.C4-GUKyp.js";
import { c as n } from "./index.CxSWpsOB.js";
const i = s("tw-inline-flex tw-items-center tw-rounded-full tw-transition-colors focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-ring focus:tw-ring-offset-2", {
  variants: {
    appearance: {
      white: "tw-border-transparent tw-bg-base-white tw-text-base-black",
      black: "tw-border-transparent tw-bg-base-black tw-text-base-white",
      purple: "tw-border-transparent tw-bg-purple-700 tw-text-base-white",
      "dark-purple": "tw-border-transparent tw-bg-purple-800 tw-text-base-white",
      gray: "tw-border-transparent tw-bg-gray-900 tw-text-base-white",
      red: "tw-border-transparent tw-bg-red-800 tw-text-base-white",
      yellow: "tw-border-transparent tw-bg-yellow-900 tw-text-base-white"
    },
    size: {
      xs: "tw-px-6 tw-py-2 tw-caption-1-b",
      sm: "tw-px-8 tw-py-4 tw-caption-2-m",
      md: "tw-px-12 tw-py-8 tw-body-1-m"
    }
  },
  defaultVariants: {
    appearance: "white",
    size: "md"
  }
});
function c({
  className: t,
  appearance: e = "white",
  size: r = "md",
  ...a
}) {
  return /* @__PURE__ */ w.jsx("div", { className: n(i({
    appearance: e,
    size: r
  }), t), ...a });
}
export {
  c as B,
  i as b
};
//# sourceMappingURL=Badge.DBCiAXBB.js.map
